import * as Yup from "yup";

export const adminOnboardingPersonalInfoSchema = Yup.object().shape({
  fullName: Yup.string().required("Full name is required"),
  phoneNumber: Yup.string().required("Phone number is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  address: Yup.string().required("Address is required"),
  //   addressLineTwo: Yup.string().required("Address Line 2 is required"),
  postalCode: Yup.string().required("Postal code is required"),
  activeCity: Yup.string().required("Active city is required"),
  activeCountry: Yup.string().required("Active country is required"),
  role: Yup.string().required("Role is required"),
  verified: Yup.string().required("Verification status is required"),
});

export const adminOnboardingCompanyInfoSchema = Yup.object().shape({
  companyName: Yup.string().required("Company name is required"),
  companyAddress: Yup.string().required("Company address is required"),
  companyPostCode: Yup.string().required("Post code is required"),
  companyCity: Yup.string().required("City is required"),
  companyRegistrationNumber: Yup.string().required(
    "Registration number is required"
  ),
  companyVATNumber: Yup.string().required("VAT number is required"),
  //   IBAN: Yup.string().required("IBAN is required"),
  //   bankAccountHolderName: Yup.string().required(
  //     "Bank account holder name is required"
  //   ),
});

export const adminOnboardingVehicleInfoSchema = Yup.object().shape({
  numberPlate: Yup.string().required("Number plate is required"),
  brandName: Yup.string().required("Brand name is required"),
  carName: Yup.string().required("Car name is required"),
  //   color: Yup.string().required("Color is required"),
  //   year: Yup.string().required("Year is required"),
  //   serviceLevel: Yup.string().required("Service level is required"),
  //   seatCapacity: Yup.string().required("Seat capacity is required"),
});
